// extracted by mini-css-extract-plugin
module.exports = {"filter":"QuoteTermsFilters_filter__3qmY1"};